import { AuditLogPage } from '@frontend/features/admin/components/AuditLogPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/audit-logs/')({
  component: AuditLogPage,
});
